import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsProfilePlaceholderXs = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M9 0a9 9 0 0 1 8.123 12.88 3 3 0 1 0-4.243 4.242A9 9 0 1 1 9 0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M9.318 3.77a2.87 2.87 0 0 1 2.871 2.87v1.608c0 .833-.355 1.582-.922 2.105a1.236 1.236 0 0 0 .054 1.87q.301.244.677.382c.263.095.544.203.833.322A3 3 0 0 0 12 15c0 .498.121.968.336 1.382A8.05 8.05 0 0 1 9 17.1a8.08 8.08 0 0 1-6.06-2.728.2.2 0 0 1 .032-.293c.884-.622 2.08-1.13 3.03-1.474.25-.09.478-.22.677-.382a1.236 1.236 0 0 0 .054-1.87 2.86 2.86 0 0 1-.922-2.105V6.64a2.87 2.87 0 0 1 2.871-2.87z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.06,
        fillRule: "nonzero",
        d: "M9 0a9 9 0 0 1 8.996 8.735L18 9l-.004.265a9 9 0 0 1-.873 3.615 3 3 0 0 0-.397-.334 8.4 8.4 0 0 0 .77-3.29L17.5 9l-.004-.255a8.5 8.5 0 1 0-4.95 7.982 3 3 0 0 0 .333.395A9 9 0 1 1 9 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsProfilePlaceholderXs$1 = SvgRsProfilePlaceholderXs;

export { SvgRsProfilePlaceholderXs$1 as default };
